import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/wage-ledger/_layout/')({
  beforeLoad: () => {
    throw redirect({
      to: '/wage-ledger/overview'
    });
  }
});